/* tslint:disable */
/* eslint-disable */
/* @relayHash 538870709b505ae8d51a2ec369c8e317 */

import { ConcreteRequest } from "relay-runtime";
export type AdminDeleteUserInput = {
    userId: string;
    clientMutationId?: string | null;
};
export type AdminDeleteUserMutationVariables = {
    input: AdminDeleteUserInput;
};
export type AdminDeleteUserMutationResponse = {
    readonly adminDeleteUser: {
        readonly id: string;
    } | null;
};
export type AdminDeleteUserMutation = {
    readonly response: AdminDeleteUserMutationResponse;
    readonly variables: AdminDeleteUserMutationVariables;
};



/*
mutation AdminDeleteUserMutation(
  $input: AdminDeleteUserInput!
) {
  adminDeleteUser(input: $input) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AdminDeleteUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "adminDeleteUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminDeleteUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AdminDeleteUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AdminDeleteUserMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AdminDeleteUserMutation",
    "id": null,
    "text": "mutation AdminDeleteUserMutation(\n  $input: AdminDeleteUserInput!\n) {\n  adminDeleteUser(input: $input) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '8ebfbb82fb8a2114c2713a27c5a5f838';
export default node;
